export default {
	props: {
		row: Object,
		product: Object
	}
}